import { defaultChartConfig, defaultDatasetConfig } from './chart-default.config';
import { IChartsConfig, IChartsDatasetConfig } from './chart-config.model';

import { aqiChartConfig, aqiDatasetConfig } from './chart-aqi.config';
import { batteryChartConfig, batteryDatasetConfig } from './chart-battery.config';
import { co2AlarmChartConfig, co2AlarmDatasetConfig } from './chart-co2-alarm.config';
import { co2AqiChartConfig, co2AqiDatasetConfig } from './chart-co2-aqi.config';
import { co2ErrorChartConfig, co2ErrorDatasetConfig } from './chart-co2-error.config';
import { co2ChartConfig, co2DatasetConfig } from './chart-co2.config';
import { gatewayCountChartConfig, gatewayCountDatasetConfig } from './chart-gateway-count.config';
import { humidityChartConfig, humidityDatasetConfig } from './chart-humidity.config';
import { messageCountChartConfig, messageCountDatasetConfig } from './chart-message-count.config';
import { mslPressureChartConfig, mslPressureDatasetConfig } from './chart-msl-pressure.config';
import { pressureChartConfig, pressureDatasetConfig } from './chart-pressure.config';
import { rssiChartConfig, rssiDatasetConfig } from './chart-rssi.config';
import { snrChartConfig, snrDatasetConfig } from './chart-snr.config';
import { socChartConfig, socDatasetConfig } from './chart-soc.config';
import { spreadingFactorChartConfig, spreadingFactorDatasetConfig } from './chart-spreading-factor.config';
import { temperatureChartConfig, temperatureDatasetConfig } from './chart-temperature.config';

export const ChartConfig: IChartsConfig = {
    aqi: aqiChartConfig,
    battery: batteryChartConfig,
    CO2_alarm: co2AlarmChartConfig,
    CO2_aqi: co2AqiChartConfig,
    CO2_error: co2ErrorChartConfig,
    CO2: co2ChartConfig,
    gateway_count: gatewayCountChartConfig,
    humidity: humidityChartConfig,
    message_count: messageCountChartConfig,
    mslPressure: mslPressureChartConfig,
    pressure: pressureChartConfig,
    rssi: rssiChartConfig,
    snr: snrChartConfig,
    SOC: socChartConfig,
    spreading_factor: spreadingFactorChartConfig,
    temperature: temperatureChartConfig,
    default: defaultChartConfig,
}

export const ChartDatasetConfig: IChartsDatasetConfig = {
    aqi: aqiDatasetConfig,
    battery: batteryDatasetConfig,
    CO2_alarm: co2AlarmDatasetConfig,
    CO2_aqi: co2AqiDatasetConfig,
    CO2_error: co2ErrorDatasetConfig,
    CO2: co2DatasetConfig,
    gateway_count: gatewayCountDatasetConfig,
    humidity: humidityDatasetConfig,
    message_count: messageCountDatasetConfig,
    mslPressure: mslPressureDatasetConfig,
    pressure: pressureDatasetConfig,
    rssi: rssiDatasetConfig,
    snr: snrDatasetConfig,
    SOC: socDatasetConfig,
    spreading_factor: spreadingFactorDatasetConfig,
    temperature: temperatureDatasetConfig,
    default: defaultDatasetConfig,
}